(function () {
  'use strict';

  if (customElements.get('jv-cart-kit-offer')) return;

  class JvCartKitOffer extends HTMLElement {
    constructor() {
      super();
      this._onClick = this.handleAdd.bind(this);
    }

    connectedCallback() {
      this.btn = this.querySelector('[data-jv-cart-kit-add]');
      this.labelEl = this.querySelector('[data-jv-cart-kit-btn-label]');
      this.btn?.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.btn?.removeEventListener('click', this._onClick);
    }

    getCartSectionIds() {
      const ids = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: ids } })
      );
      return ids;
    }

    parseVariantUpdates() {
      const raw = this.dataset.variantUpdates || '';
      const updates = {};
      raw.split(',').forEach((pair) => {
        const [id, qty] = pair.trim().split(':');
        if (id) updates[id] = parseInt(qty, 10) || 0;
      });
      return updates;
    } 

    async handleAdd(event) {
      event.preventDefault();
      if (!this.btn || this.btn.disabled) return;

      const variantId = parseInt(this.dataset.kitVariantId, 10);
      const updates = this.parseVariantUpdates();
      if (!variantId || !Object.keys(updates).length) return;

      const { MinimogSettings } = window;
      const routes = MinimogSettings?.routes || {};
      const prevLabel = this.labelEl?.textContent || '';
      const sections = this.getCartSectionIds();
      const sectionsUrl = window.location.pathname;

      this.btn.disabled = true;
      this.btn.classList.add('m-spinner-loading');
      if (this.labelEl) this.labelEl.textContent = 'Adicionando...';

      const fetchOpts = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin'
          };

      try {
        const updateConfig = {
          ...fetchOpts,
          body: JSON.stringify({ updates, sections, sections_url: sectionsUrl })
        };
        const updateRes = await fetch(routes.cart_update_url || '/cart/update.js', updateConfig);
        const updateData = await updateRes.json();

        if (updateData.status) {
          throw new Error(updateData.description || updateData.message || 'Erro ao atualizar carrinho');
        }

        const addConfig = {
          ...fetchOpts,
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections,
            sections_url: sectionsUrl
          })
        };
        const addRes = await fetch(routes.cart_add_url || '/cart/add.js', addConfig);
        const addData = await addRes.json();

        if (addData.status) {
          throw new Error(addData.description || addData.message || 'Erro ao adicionar kit');
        }

        if (this.labelEl) this.labelEl.textContent = 'Adicionado!';

        if (MinimogSettings?.use_ajax_atc) {
          window.MinimogEvents?.emit(MinimogTheme.pubSubEvents.cartUpdate, {
            cart: addData,
            productVariantId: String(variantId)
          });
        } else {
          window.location = routes.cart || '/cart';
          return;
        }

        setTimeout(() => {
          if (this.labelEl) this.labelEl.textContent = prevLabel;
          this.btn.disabled = false;
          this.btn.classList.remove('m-spinner-loading');
        }, 1200);
      } catch (err) {
        console.error('[jv-cart-kit-offer]', err);
        if (this.labelEl) this.labelEl.textContent = 'Erro — tente novamente';
        window.MinimogTheme?.Notification?.show({
          target: this.btn,
          method: 'appendChild',
          type: 'error',
          message: err.message || 'Não foi possível adicionar o kit.',
          last: 3500
        });
        setTimeout(() => {
          if (this.labelEl) this.labelEl.textContent = prevLabel;
          this.btn.disabled = false;
          this.btn.classList.remove('m-spinner-loading');
        }, 3000);
      }
    }
  }

  customElements.define('jv-cart-kit-offer', JvCartKitOffer);
})();
